import { FC } from 'react';
import { t } from 'i18next';
import parse from 'html-react-parser';
import styles from './editProtectedSpaces.module.scss';
import { ObraProperties } from '../../../../../types/ObraDetails';
import { ValidationError } from '../../../../../types/ValidationError';
import TitleHelp from '../../../components/titleHelp/titleHelp';
import ProtectedSpace from '../../components/protectedSpace/protectedSpace';
import protectionSpace from '../../../../../assets/protectionSpace.svg';

interface EditProtectedSpacesProps {
  obra: ObraProperties;
  errors?: ValidationError[];
}

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const EditProtectedSpaces: FC<EditProtectedSpacesProps> = (props) => {
  const { obra, errors } = props;

  return (
    <div className={styles.protectedpacesContainer}>
      <TitleHelp
        id='protectedspace'
        value={t('details.location.protectedSpace')}
        help={t('help.localization.protectedSpace')}
      />
      {
        obra.localizacion.espacioProteccion.length > 0 ?
          <ProtectedSpace obra={obra} errors={errors} editable={false} />
          :
          <div id='protectionspace-nodata' className={styles.noDataPic}>
            <img src={protectionSpace} />
            <p>{parse(t('details.location.noData'))}</p>
          </div>
      }
    </div >
  );
};

export default EditProtectedSpaces;
